import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";

// Hero and content image
import heroImg from "../../assets/9.jpg"; 
import contentImg from "../../assets/hosp.jpg"; 

// Import local project images dynamically (h11.webp to h77.webp, 9 images)
const projectImages = [
  require('../../assets/h11.webp'),
  require('../../assets/h22.webp'),
  require('../../assets/h33.webp'),
  require('../../assets/h44.webp'),
  require('../../assets/h55.webp'),
  require('../../assets/h66.webp'),
  require('../../assets/h77.webp'),
  require('../../assets/h11.webp'), // repeat if needed
  require('../../assets/h22.webp'), // repeat if needed
];

const Hospital = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[430px] relative flex items-center justify-start px-6 md:px-12"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">Home</p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">
            Hospital
          </h1>
        </motion.div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 space-y-6"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0, transition: { staggerChildren: 0.3 } },
          }}
        >
          <motion.p
            className="text-gray-700 text-lg leading-relaxed text-justify"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            Hospital lifts are a crucial component for any healthcare facility, including hospitals, clinics, nursing homes, and medical centers of all sizes. These lifts provide a safe, reliable, and efficient way to transport patients, medical staff, and equipment within the facility.
          </motion.p>
          <motion.p
            className="text-gray-700 text-lg leading-relaxed text-justify"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            Often referred to as ‘Stretcher Lifts’ or ‘Bed Lifts’, WVT Elevators offers a broad range of load capacities and car sizes to meet the unique needs of modern healthcare environments. Our hospital lifts come equipped with advanced door sensors for safe and smooth door operation, as well as variable frequency drives for precise control and smooth acceleration. These features ensure the safety, comfort, and convenience of both patients and staff during transport.
          </motion.p>
          <motion.p
            className="text-gray-700 text-lg leading-relaxed text-justify"
            variants={{ hidden: { opacity: 0 }, visible: { opacity: 1 } }}
          >
            Whether you’re moving patients between floors or transporting medical supplies, our hospital lifts provide the ideal solution for your healthcare facility. Contact us today to discuss a reliable and efficient lift solution tailored to your hospital’s needs.
          </motion.p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 w-full overflow-hidden rounded-2xl shadow-2xl"
          initial={{ opacity: 0, scale: 0.8, x: 50 }}
          whileInView={{ opacity: 1, scale: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={contentImg}
            alt="Hospital Lift"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl"
          />
        </motion.div>
      </div>

      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10">
          SOME PROJECTS
        </h2>

        <Slider {...sliderSettings}>
          {projectImages.map((img, idx) => (
            <motion.div
              key={idx}
              className="px-2"
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: idx * 0.1 }}
            >
              <img
                src={img}
                alt={`Project ${idx + 1}`}
                className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
              />
            </motion.div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Hospital;
